var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTable11 = function SvgTable11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 3L21 3L21 4.98452L19.8 4.98452L19.8 4.2L12.6 4.2L12.6 4.98452L11.4 4.98452L11.4 4.2L4.2 4.2L4.2 4.98452L3 4.98452L3 3L11.4 3L12.6 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 6.97656L12.6 6.97656L12.6 8.99204L11.4 8.99204L11.4 6.97656Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.97656L4.2 6.97656L4.2 8.99204L3 8.99204L3 6.97656Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.97656L19.8 6.97656L19.8 8.99204L21 8.99204L21 6.97656Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.4L19.8 11.4L19.0033 11.4L19.0033 12.6L19.8 12.6L21 12.6L21 11.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0112 12.6L17.0112 11.4L14.9957 11.4L14.9957 12.6L17.0112 12.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 11.4L13.0037 11.4L13.0037 12.6L12.6 12.6L11.4 12.6L11.0351 12.6L11.0351 11.4L11.4 11.4L12.6 11.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01961 12.6L9.01961 11.4L7.02757 11.4L7.02757 12.6L9.01961 12.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 11.4L5.01378 11.4L5.01378 12.6L4.2 12.6L3 12.6L3 11.4L4.2 11.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 14.9916L21 14.9916L21 17.0071L19.8 17.0071L19.8 14.9916Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21L21 19.0035L19.8 19.0035L19.8 19.8L19.0033 19.8L19.0033 21L21 21Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0112 21L17.0112 19.8L14.9957 19.8L14.9957 21L17.0112 21Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 21L12.6 19.8L12.6 19.0035L11.4 19.0035L11.4 19.8L11.4 21L12.6 21Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 17.0071L11.4 17.0071L11.4 14.9916L12.6 14.9916L12.6 17.0071Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.9916L4.2 14.9916L4.2 17.0071L3 17.0071L3 14.9916Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 19.0035L4.2 19.8L5.01378 19.8L5.01378 21L3 21L3 19.0035L4.2 19.0035Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02757 21L7.02757 19.8L9.01961 19.8L9.01961 21L7.02757 21Z"
  })));
};
export default SvgTable11;